module.exports = __webpack_public_path__ + "img/features_1.a23f0856.png";